import { render } from "./QuestionEditor.vue?vue&type=template&id=7f06f4a4&scoped=true"
import script from "./QuestionEditor.vue?vue&type=script&lang=js"
export * from "./QuestionEditor.vue?vue&type=script&lang=js"

import "./QuestionEditor.vue?vue&type=style&index=0&id=7f06f4a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f06f4a4"]])

export default __exports__